import { apiFetch } from "../../../../services/api-fetch";
import getWordEnding from "../../../../services/helpers/get-word-ending";

import * as commentDom from "./dom";
import { triggerEvent } from "../../../../services/helpers/trigger-event";

import { init as initPicture } from "../../../../services/picture-fallback";

const attrs = {
  foldAttr: "data-fold",
  loadAttr: "data-loading"
};

// контейнер корневых комментариев
let root;

/**
 * Развернуть свернутую ветку
 * @param { HTMLElement } list Свернутый контейнер комментариев
 */
const unfoldCommentBranch = (commentData) => {
  // отобразить процесс подгрузки
  if (commentData.more) {
    commentData.more.setAttribute(attrs.loadAttr, "");
  }

  // инициализировать каждый комментарий в списке
  commentData.children.forEach(comment => {
    initCommentBranch(comment.element);
  });

  // развернуть ветку
  commentData.childrenList.removeAttribute(attrs.foldAttr);
}

/**
 * Свернуть ветку, в которой больше двух потомков
 * @param { HTMLElement } list 
 * @param { number } descendants количество потомков, которые будут отображены при разворачивании ветки
 */
const foldCommentBranch = (commentData, willBeUnfold) => {
  // свернуть ветку
  commentData.childrenList.setAttribute("data-fold", "");

  // найти самый свежий комментарий в ветке
  let recentComment = commentDom.findLastComment(commentData.children);
  recentComment.element.classList.add('recent');

  // обновить кнопку Больше ответов
  commentData.more.textContent = willBeUnfold + " " + getWordEnding(willBeUnfold, ['ответ', 'ответа', 'ответов'])
  // при клике на кнопку Больше ответов развернуть ветку
  commentData.more.addEventListener("click", e => {
    unfoldCommentBranch(commentData);
  });
}

/**
 * Инициализировать ветку комментариев
 * до двух потомков - вывести всех
 * больше двух - вывести автора самого свежего ребенка и кнопку Еще n ответов
 * @param { HTMLElement } comment 
 */
const initCommentBranch = (comment, open) => {
  let commentData = commentDom.getDescendants(comment, 4);
  if (commentData.childrenCount > 2) {
    let willBeUnfold = commentData.children.reduce((total, comment) => {
      // у ребенка больше двух детей - подгрузится только сам ребенок
      if (comment.childrenCount > 2) return total + 1;
      // подгрузится сам ребенок и его дети
      else return total + comment.childrenCount + 1;
    }, 0);
    if (open) unfoldCommentBranch(commentData);
    else foldCommentBranch(commentData, willBeUnfold);
  }
}

/** 
 * Отобразить корневые комментарии 
 */
const initCommentsList = () => {
  let rootComments = commentDom.getChildren(root);

  rootComments.forEach(rootComment => {
    initCommentBranch(rootComment);
  });

  const filter = document.querySelector('[data-comments-filter]:not([data-hidden])');

  if (filter) {
    filter.style.display = "block";
  }
};

/**
 *
 */
const protectLinks = (parent) => {
  parent.querySelectorAll("a")
  .forEach(link => link.setAttribute("rel", "noopener noreferrer nofollow"))
};

const unfoldCommentParents = (commentElement) => {
  let parents = [];
  let list = commentElement.closest('.comment__children');

  while(list) {
    let parent = list.closest('.comment');
    if (!parent) break;
    list = parent.closest('.comment__children');
    if (parent) {
      parents.push(parent);
    }
  }

  parents.reverse().forEach(commentEntity => {
    let comment = commentEntity.closest('.comment');
    initCommentBranch(comment, "open");
  })
};

const doActions = () => {
  let url = new URL(window.location.href);
  

  let commentId =  url.searchParams.get('comment');
  if (!commentId) return;

  let commentElement = root.querySelector(`.comment-entity[data-id="${commentId}"]`);
  if (!commentElement) return;

  unfoldCommentParents(commentElement);

  let action = url.searchParams.get('action');
  if (action === "answer" || action === "edit") {
    let buttonSelector = action === "answer" ? "[data-comment-reply]" : "[data-comment-edit]";
    let button = commentElement.querySelector(buttonSelector);
    if (button) {
      button.click();
    }
  }

  document.querySelector(`#comment-${commentId}`).scrollIntoView();
}

/**
 * Загрузить все комментарии
 * @param { HTMLElement } list 
 */
const loadComments = (list) => {
  return new Promise((resolve, reject) => {
    root = list;
    let action = root.dataset.action;

    if (!action) reject();

    apiFetch(action, {
      method: "POST"
    }).then(res => {
      if (res.success) {
        let html = res.html.trim();
        if (html) {
          root.innerHTML = res.html;
          protectLinks(root);
          initCommentsList();
          root.querySelectorAll("picture img").forEach(initPicture);
        }
        root.setAttribute("data-loaded", "");
        root.removeAttribute("data-error");
        root.style.display = "";
        triggerEvent(document.body, "update.lazy");
        doActions();
        resolve();
      } else {
        root.setAttribute("data-error", "");
        root.style.display = "";
        reject();
      }
    }).catch(error => {
      root.setAttribute("data-error", "");
      root.style.display = "";
      console.error(error);
      reject();
    })
  })
  
};

export { loadComments };